const tabs = document.querySelectorAll('.tabs__list');
const tabsField = document.querySelectorAll('.tabs-field');

for (let i = 0; i < tabs.length; i++) {
  const cabins = tabsField[i].querySelectorAll('.tabs-item');
  tabs[i].addEventListener('click', (e) => {
    if (tabs[i].dataset.scroll) {
      window.scrollTo({
        top: tabsField[i].getBoundingClientRect().top + window.pageYOffset - document.querySelector('header').clientHeight - 60,
        behavior: 'smooth'
      });
    }

    if (e.target.classList.contains('tabs__button')) {
      tabs[i].querySelectorAll('.tabs__button').forEach(item => {
        item.classList.remove('tabs__button_active')
      })
      cabins.forEach((item, i) => {
        item.style.display = 'none';
      })
      tabsField[i].querySelectorAll(`.tabs-ship-item`).forEach((elem, i) => {
        elem.style.display = 'none';
      });
      tabsField[i].querySelectorAll(`.tabs-ship-item[data-${e.target.dataset.type}]`).forEach((elem, index, mas) => {
        elem.style.display = null;
      })
      tabsField[i].querySelectorAll(`.tabs-item[data-${e.target.dataset.type}]`).forEach((item, index, mas) => {
        item.style.display = null;
        if(mas.length > 1) {
          if (document.documentElement.clientWidth >= 1071)
            item.style.marginRight = (index + 1) % 3 ? '1.3%' : null;
        }
      })

      e.target.classList.add('tabs__button_active');

      if (!e.target.dataset.type) {
        cabins.forEach(item => {
          item.style.display = null;
        })
      }
      if (tabsField[i].dataset.ship) {
        if(Array.isArray(mobileSwiper)) {
          mobileSwiper.forEach(item => {
            item.updateSlides();
            item.slideTo(0, 0);
            item.scrollbar.updateSize()
          })
        } else {
          mobileSwiper.updateSlides();
          mobileSwiper.slideTo(0, 0);
          mobileSwiper.scrollbar.updateSize()
        }
      }
    }
  })
}

for (let i = 0; i < tabsField.length; i++) {
  document.querySelectorAll('.tabs__button_active').forEach(item => {
    tabsField[i].querySelectorAll(`.tabs-item`).forEach((elem, i) => {
      elem.style.display = 'none';
    });
    tabsField[i].querySelectorAll(`.tabs-ship-item`).forEach((elem, i) => {
      elem.style.display = 'none';
    });
    setTimeout(() => {
      tabsField[i].querySelectorAll(`.tabs-ship-item[data-${item.dataset.type}]`).forEach((elem, index, mas) => {
        elem.style.display = null;
      })
      tabsField[i].querySelectorAll(`.tabs-item[data-${item.dataset.type}]`).forEach((elem, index, mas) => {
        elem.style.display = null;
        if(mas.length > 1) {
          if (document.documentElement.clientWidth >= 1071)
          elem.style.marginRight = (index + 1) % 3 ? '1.3%' : null;
        }
      })
    }, 0)
  })

}

const routeTabs = document.querySelectorAll('.route-to-day__nav')

const resizeTabs = () => {
  if (document.querySelector('.breadcrumb')) {
    const temp = document.querySelector('.breadcrumb').clientHeight
      ? document.querySelector('.breadcrumb').clientHeight + 18
      : 1
    const tops = document.querySelector('.header').clientHeight - temp
  
    routeTabs.forEach(item => {
      item.style.top = tops + 'px';
    })
  }
}

window.addEventListener('resize', resizeTabs)
resizeTabs()